import { useSafeAreaInsets } from "react-native-safe-area-context";
import { graphql, useFragment } from "react-relay";
import { useSizeClass } from "@/src/common/Utils/useSizeClass";
import { AHText, Box, Card, Input } from "arkh";

import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { CalendarAdminComponent_store$key } from "./__generated__/CalendarAdminComponent_store.graphql";
import { ColorSelect } from "../TodoCategoryAdmin/ColorSelect";

import { SizeClass } from "@/src/common/Utils/SizeClass";
import {
  TeamSelectList,
  TeamSelectListWholeStoreOption,
} from "widgets/src/TeamSelectList";

export function CalendarAdminComponent(props: {
  title: string;
  setTitle: (title: string) => void;
  color: string | undefined;
  setColor: (color: string) => void;
  iCalUrl: string | null;
  teamIds: string[];
  setTeamIds: (teamIds: string[]) => void;
  store: CalendarAdminComponent_store$key;
}) {
  const store = useFragment(
    graphql`
      fragment CalendarAdminComponent_store on Store {
        publicTeams {
          ...TeamSelectList_Team
        }
      }
    `,
    props.store
  );
  const intl_tokens = useIntlTokens();
  const safeAreaInsets = useSafeAreaInsets();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;

  return (
    <TeamSelectList
      onItemPress={(itemId, selected) => {
        props.setTeamIds(
          selected
            ? props.teamIds.filter((id) => id !== itemId)
            : [...props.teamIds, itemId]
        );
      }}
      selected={props.teamIds}
      teams={store.publicTeams}
      contentBox={{
        space: "medium",
      }}
      insets={isCompact ? { bottom: safeAreaInsets.bottom } : undefined}
      ListHeaderComponent={
        <Box spaceTop="medium">
          <Input
            value={props.title}
            onChangeText={props.setTitle}
            placeholder={intl_tokens.Title}
            autoCapitalize="sentences"
          />
          <AHText
            type="title-small"
            spaceHorizontal="medium"
            spaceTop="medium"
            spaceBottom="small"
          >
            {intl_tokens.Color}
          </AHText>
          <Card defaultBorder>
            <ColorSelect selected={props.color} setSelected={props.setColor} />
          </Card>
          {props.iCalUrl ? (
            <>
              <AHText
                type="title-small"
                spaceHorizontal="medium"
                spaceTop="medium"
                spaceBottom="small"
              >
                {intl_tokens.SubscriptionLink}
              </AHText>
              <Card defaultBorder>
                <AHText>{props.iCalUrl}</AHText>
              </Card>
            </>
          ) : null}
          <AHText
            type="title-small"
            spaceHorizontal="medium"
            spaceTop="medium"
            spaceBottom="small"
          >
            {intl_tokens.Teams}
          </AHText>
          <TeamSelectListWholeStoreOption
            onSelect={() => props.setTeamIds([])}
            selected={props.teamIds.length === 0}
          />
        </Box>
      }
    />
  );
}
